module.exports = __webpack_public_path__ + "img/Trinasolar.00e3aca1.png";